<template>
  <div>
    <h3>{{ text }}</h3>
    <CallPlanningTerritoryTable class="mt-3" text="Regions" :data="valueRegions" idProp="regionId" :territories="regions" @add="add('regionId', $event)" @remove="remove('regionId', $event)" />
    <CallPlanningTerritoryTable class="mt-3" text="Territories" :data="valueTerritories" idProp="territoryId" :territories="territories" @add="add('territoryId', $event)" @remove="remove('territoryId', $event)" />
    <CallPlanningFindZips @input="showAdd = false" v-if="showAdd" />
  </div>
</template>

<script>
import CallPlanningFindZips from './CallPlanningFindTerritories.vue';
import CallPlanningTerritoryTable from './CallPlanningTerritoryTable.vue';
export default {
  components: { CallPlanningFindZips, CallPlanningTerritoryTable, },
  props: ['value', 'text', 'regions', 'territories'],
  data() {
    return {
      showAdd: false,
      tableState: { page: 1, perPage: 50 },
    };
  },
  computed: {
    valueRegions() {
      var selected = (this.value || [])
        .filter(f => f.regionId)
        .reduce((acc, f) => { acc[f.regionId] = true; return acc; }, {});
      return this.regions
        .filter(f => selected[f.id]);
    },
    valueTerritories() {
      var selected = (this.value || [])
        .filter(f => f.territoryId)
        .reduce((acc, f) => { acc[f.territoryId] = true; return acc; }, {});
      return this.territories
        .filter(f => selected[f.id]);
    },
  },
  methods: {
    add(prop, item) {
      this.$emit('input', [...this.value, { [prop]: item.id }]);
    },
    remove(prop, item) {
      this.$emit('input', this.value.filter(f => f[prop] !== item.id));
    },
  }
}
</script>